export default async function getMenuData() {
  return [
    {
      title: "Facility",
      key: "facility",
      icon: "icmn-svg",
      url: "/facility"
    },
    {
      title: "Lots",
      key: "lots",
      icon: "icmn-list",
      url: "/multiple-facility-lots"
    },
    {
      category: true,
      title: "Sales Portfolio"
    },
    {
      title: "Vendor",
      key: "vendors",
      icon: "fa fa-vimeo",
      children: [
        {
          title: "Vendors",
          key: "vendor",
          icon: "fa fa-group",
          url: "/vendor"
        },
        {
          title: "Vendor Search",
          key: "searchVendor",
          icon: "fe fe-zoom-in",
          url: "/vendor-search"
        },
        {
          title: "Lot Invoice",
          key: "lotInvoice",
          icon: "fa fa-file-pdf-o",
          url: "/vendor/lot-invoice"
        }
      ]
    },
    {
      title: "Lot Discount",
      key: "lotDiscount",
      icon: "icmn-quill",
      url: "/lot-discount"
    },
    {
      title: "Additional Lot Discount",
      key: "additionalLotDiscount",
      icon: "fa fa-percent",
      url: "/additional-lot-discount"
    },
    {
      title: "Lot Simulation",
      key: "lotSimulation",
      icon: "icmn-quill",
      url: "/lot-simulation"
    },
    {
      title: "Analylics",
      key: "Analylics",
      icon: "fe fe-trending-up",
      children: [
        {
          title: "Current Inventory",
          key: "inventory",
          icon: "fe fe-smartphone",
          url: "/analytics/inventory/brand",
          roles: ["ROLE_SALES_ADMIN", "ROLE_ZONAL_MANAGER", "ROLE_ASM_SALES"]
        },
        {
          title: "Lot Summary",
          key: "lotSummary",
          icon: "fa fa-object-group",
          url: "/analytics/lot-summary",
          roles: ["ROLE_SALES_ADMIN", "ROLE_ZONAL_MANAGER", "ROLE_ASM_SALES"]
        },
        {
          title: "Ageing",
          key: "unPublishPrice",
          icon: "fa fa-balance-scale",
          url: "/analytics/brand-ageing",
          roles: ["ROLE_SALES_ADMIN", "ROLE_ZONAL_MANAGER", "ROLE_ASM_SALES"]
        },
        {
          title: "Product Price",
          key: "productPrice",
          icon: "fa fa-inr",
          url: "/analytics/product-price"
        }
      ]
    },
    {
      category: true,
      title: "Download"
    },
    {
      title: "Downloads",
      key: "download",
      icon: "fe fe-download",
      url: "/download"
    },
    {
      title: "User",
      key: "user",
      icon: "icmn-users",
      url: "/user",
      roles: ["ROLE_SALES_ADMIN"]
    },
    {
      title: "Facility Limits",
      key: "returnLimit",
      icon: "icmn-undo2",
      url: "/facility/return-limit",
      roles: ["ROLE_SALES_ADMIN"]
    },
    {
      title: "Refund",
      key: "refund",
      icon: "icmn-list",
      url: "/refund",
      roles: ["ROLE_SALES_ADMIN"]
    }
  ];
}
